<template>
  <div class="desk-frame">
    <div class="head_row_calander bg--white flex no_mobile">
      <h2 class="head_row_title_page">סיכום חודשי {{ getDate }}</h2>
    </div>
    <menu-desktop class="no_mobile" />
    <DashboardHeader />
    <transition name="slide">
      <Menu v-if="MENU_ACTIVE" />
    </transition>
    <transition name="slide">
      <div class="summery-page sec--pad">
        <div class="inner_width desk-flex desk-flex--top">
          <div class="summery-box consultants bg--yellow">
            <div class="summery-box-top flex">
              <div class="number">
                {{ totalConsultations }}
                <div class="">ייעוצים</div>
              </div>
              <div class="icon"><img src="assets/img/svg/statos.svg" /></div>
            </div>
            <div class="summery-box-bottom">
              <div
                class="title relative flex"
                @click="setActive($event, 'consultation')"
              >
                <div class="title-in">גורמים משלמים</div>
                <div class="drop">
                  <img src="assets/img/svg/arrow_down.svg" />
                </div>
              </div>
              <transition name="slide">
                <div class="insurance-rows" v-show="show.consultation">
                  <div
                    class="flex"
                    v-for="(row, index) in data"
                    :key="index + '-' + row['insuance']"
                  >
                    <div class="col1">{{ row["insurance"] }}</div>
                    <div class="col2">{{ row["consultation"] }}</div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
          <div class="summery-box operations bg--blue-lighter">
            <div class="summery-box-top flex">
              <div class="number">
                {{ totalOperations }}
                <div class="">פעולות</div>
              </div>
              <div class="icon"><img src="assets/img/svg/case.svg" /></div>
            </div>
            <div class="summery-box-bottom">
              <div
                class="title relative flex"
                @click="setActive($event, 'operations')"
              >
                <div class="title-in">גורמים משלמים</div>
                <div class="drop">
                  <img src="assets/img/svg/arrow_down.svg" />
                </div>
              </div>
              <transition name="slide">
                <div class="insurance-rows" v-show="show['operations']">
                  <div
                    class="flex"
                    v-for="(row, index) in data"
                    :key="index + '-' + row['insuance']"
                  >
                    <div class="col1">{{ row["insurance"] }}</div>
                    <div class="col2">{{ row["operations"] }}</div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
          <div class="summery-box total-payed bg--green-light">
            <div class="summery-box-top flex">
              <div class="number">
                <span class="shekel">₪</span>{{ totalPayed }}
                <div>סה״כ שולם</div>
              </div>
              <div class="icon"><img src="assets/img/svg/wolet.svg" /></div>
            </div>
          </div>
        </div>
        <div class="inner_width">
          <div class="last-upd">עדכון אחרון: 31/01/2022</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import DashboardHeader from "@/components/Shared/Header";
import Menu from "@/components/Shared/Menu";
import { mapGetters, mapMutations, mapState } from "vuex";
import PAPA from "papaparse/papaparse.js";
import MenuDesktop from "@/components/Shared/MenuDesktop.vue";
export default {
  name: "SummeryPage",

  components: {
    Menu,
    DashboardHeader,
    MenuDesktop
  },
  computed: {
    ...mapGetters(["MENU_ACTIVE", "activeDoctor"]),
    ...mapState(["activeUser"]),
    totalConsultations() {
      let count = 0;
      const data = this.data;
      if (data.length > 0) {
        for (const key in data) {
          count += data[key]["consultation"];
        }
      }
      return count;
    },
    totalOperations() {
      let count = 0;
      const data = this.data;
      if (data.length > 0) {
        for (const key in data) {
          count += data[key]["operations"];
        }
      }
      return count;
    },
    totalPayed() {
      let count = 0;
      const data = this.data;
      if (data.length > 0) {
        for (const key in data) {
          count += data[key]["payments"];
        }
      }
      return count;
    },
    getDate() {
      return (
        this.$moment(new Date()).format("MMMM") +
        " " +
        this.$moment(new Date()).format("YYYY")
      );
    }
  },
  data: function() {
    return {
      loaded: false,
      title: "",
      errorMessge: "",
      data: [],
      show: {
        consultation: false,
        operations: false
      }
    };
  },
  methods: {
    ...mapMutations(["UPDATE_MENU_STATE"]),
    setActive($event, operation) {
      /** @type {HTMLElement} */
      let element = $event.target;

      if (!element.classList.contains("title")) {
        element = element.closest(".title");
      }
      this.show[operation] = !this.show[operation];
      element.classList.toggle("active");
    }
  },
  watch: {
    "this.activeDoctor": function(value) {
      const _this = this;
      var dataObject = [];
      var doctor_license = this.activeDoctor.license || "1115";
      //this.UPDATE_MENU_STATE(false);
      PAPA.parse(`https://hmc.co.il/zimunbook/${doctor_license}.csv`, {
        download: true,
        complete: function(results) {
          const data = results.data;
          for (const index in data) {
            if (index == 1) continue;
            if (data.hasOwnProperty.call(data, index)) {
              const row = data[index];
              if (index == 0) {
                _this.title = row[0];
                continue;
              }

              var temp = {
                insurance: row[0],
                consultation: parseInt(row[1]),
                operations: parseInt(row[2]),
                payments: parseFloat(row[3])
              };
              dataObject.push(temp);
            }
          }

          _this.data = dataObject;
        }
      });
    }
  },
  mounted() {
    this.loaded = true;
    const _this = this;
    var dataObject = [];
    var doctor_license = "11115";
    if (this.activeDoctor) {
      doctor_license = this.activeDoctor.license;
    }

    //this.UPDATE_MENU_STATE(false);
    PAPA.parse(`https://hmc.co.il/zimunbook/${doctor_license}.csv`, {
      download: true,
      complete: function(results) {
        const data = results.data;
        for (const index in data) {
          if (index == 1) continue;
          if (data.hasOwnProperty.call(data, index)) {
            const row = data[index];
            if (index == 0) {
              _this.title = row[0];
              continue;
            }

            var temp = {
              insurance: row[0],
              consultation: parseInt(row[1]),
              operations: parseInt(row[2]),
              payments: parseFloat(row[3])
            };
            dataObject.push(temp);
          }
        }

        const pageTitle = document.getElementById("pageTitle");
        pageTitle.innerText = _this.title;
        _this.data = dataObject;
      }
    });
  },
  created() {}
};
</script>
<style></style>
